/* eslint-disable */
import React, { Suspense, lazy } from "react";

// Lazy load the App component
const App = lazy(() => import("App"));
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { AuthContextProvider } from "helpers/authContext";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <AuthContextProvider>
      <MaterialUIControllerProvider>
        <Suspense>
          <App />
        </Suspense>
      </MaterialUIControllerProvider>
    </AuthContextProvider>
  </BrowserRouter>
);
